import AppSvgIcon from './AppSvgIcon.vue';
export default AppSvgIcon;



// WEBPACK FOOTER //
// ./src/uikit/components/AppSvgIcon/index.ts